import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { LoginPage } from './components/LoginPage/LoginPage';
import { MainLayout } from './components/MainLayout/MainLayout';
import { DashboardPage } from './pages/DashboardPage';
import { ForaKitPage } from './pages/ForaKitPage';
import { IAPage } from './pages/IAPage';
import { InputPage } from './pages/InputPage';

// Este componente verifica se o usuário está logado
const PrivateRoutes = () => {
  const isAuth = !!localStorage.getItem('ccomex_token'); // Verifica se o token existe
  return isAuth ? <Outlet /> : <Navigate to="/login" />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rota pública para o login */}
        <Route path="/login" element={<LoginPage />} />

        {/* Rotas privadas que exigem login */}
        <Route element={<PrivateRoutes />}>
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/fora-kit" element={<ForaKitPage />} />
            <Route path="/ia" element={<IAPage />} />
            <Route path="/input" element={<InputPage />} />
          </Route>
        </Route>

        {/* Redirecionamento padrão: se entrar na raiz, vai para o dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;